import moment from "moment";
import { check } from "../../../resources/js/images";
import Container from "../../../shared/Container";
import Section from "../../../shared/Section";
import P from "../../../shared/typography/P";
import CloseButton from "../../../shared/ui/CloseButton";
import Info from "../../../shared/ui/Info";

const AdminProjectStage = ({ onClick, workflow }) => {
    return (
        <Section className=" bg-white pb-6 mb-0">
            <div className="min-h-[128px] bg-blue-700 lg:hidden "></div>
            <div className="pt-2 rounded-3 bg-white -mt-3 lg:mt-0">
                <Container>
                    <CloseButton onClick={onClick} className="lg:hidden" />
                    {workflow.length === 0 ? (
                        <Info message="Workflow has not yet initiated" />
                    ) : (
                        workflow.map((workflowItem) =>
                            workflowItem.states
                                ?.sort((a, b) => a.stateId - b.stateId)
                                ?.map((item, index) => (
                                    <div key={index} className="mb-2">
                                        <div className="flex items-center justify-between  mb-1.5">
                                            <div className="w-1 h-1 rounded-full bg-primary"></div>
                                            <P className="text-sm font-vietnam w-[80%]">
                                                {item.name}
                                            </P>
                                            <div className="w-2.4 h-2.4">
                                                {item.stateStatus ===
                                                "COMPLETED" ? (
                                                    <img
                                                        src={check}
                                                        alt="check"
                                                    />
                                                ) : (
                                                    <div className="w-full h-full bg-blue-200 border border-blue-50 rounded-full"></div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="flex justify-center">
                                            <div className="w-[82%]">
                                                <div className="flex items-center justify-between mb-1">
                                                    <P className="text-xs font-vietnam font-light text-gray-500">
                                                        {typeof item?.actualStartTime ===
                                                        "number"
                                                            ? moment(
                                                                  item.actualStartTime *
                                                                      1000
                                                              ).format(
                                                                  "DD/MM/yyy"
                                                              )
                                                            : "Date: N/A"}
                                                    </P>

                                                    <P className="text-xs font-vietnam font-light text-gray-500">
                                                        ETA:{" "}
                                                        {item?.completionTime}
                                                        Days
                                                    </P>
                                                </div>
                                                <div
                                                    className="text-xs font-vietnam font-light text-secondary list-disc"
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.description,
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                        )
                    )}
                </Container>
            </div>
        </Section>
    );
};

export default AdminProjectStage;
